import { render, staticRenderFns } from "./createSupplies.vue?vue&type=template&id=859672be&"
import script from "./createSupplies.vue?vue&type=script&lang=js&"
export * from "./createSupplies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports